<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <div>
            <md-dialog-confirm
                :md-active.sync="deleteConfirm"
                md-title="Confirmación"
                md-content="¿Desea elminar este usuario?"
                md-confirm-text="Borrar"
                md-cancel-text="Cancelar"
                @md-cancel="deleteConfirm = false"
                @md-confirm="onDeleteConfirm" />

            <md-content v-if="showDialog">
                <form novalidate class="md-layout" @submit.prevent="validateItem">
                <md-card class="md-layout-item">
                    <md-card-header>
                    <div class="md-title" v-if="!formForEdit">Nuevo usuario</div>
                    <div class="md-title" v-if="formForEdit">Modificar usuario</div>
                    </md-card-header>

                    <md-card-content>
                        <md-field>
                            <label for="name">Nombre</label>
                            <md-input name="name" id="name" v-model="form.name" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="email">Email</label>
                            <md-input type="email" name="email" id="email" v-model="form.email" :disabled="sending || formForEdit" />
                        </md-field>

                        <md-field v-if="!formForEdit">
                            <label for="password">Clave</label>
                            <md-input type="password" name="password" id="password" v-model="form.password" :disabled="sending" />
                        </md-field>

                        <br />
                        <div class="md-title">Permisos</div>
                        <md-checkbox v-model="form.permissions.isAdmin">Administrador <small>(puede ingresar al sitio de gestión)</small></md-checkbox><br />
                        <md-checkbox v-model="form.permissions.createsUsers" class="md-primary">Crea Usuarios</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.modifiesUsers" class="md-primary">Modifica Usuarios</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.deletesUsers" class="md-primary">Elimina Usuarios</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.createsCategories" class="md-primary">Crea Categorias</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.modifiesCategories" class="md-primary">Modifica Categorias</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.aprovesCategories" class="md-primary">Aprueba Categorias</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.suspendsCategories" class="md-primary">Suspende Categorias</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.deletesCategories" class="md-primary">Elimina Categorias</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.createsQuestions" class="md-primary">Crea Preguntas</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.modifiesQuestions" class="md-primary">Modifica Preguntas</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.aprovesQuestions" class="md-primary">Aprueba Preguntas</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.deletesQuestions" class="md-primary">Elimina Preguntas</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.createsSchools" class="md-primary">Crea Establecimientos</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.modifiesSchools" class="md-primary">Modifica Establecimientos</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.aprovesSchools" class="md-primary">Aprueba Establecimientos</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.suspendsSchools" class="md-primary">Suspende Establecimientos</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.deletesSchools" class="md-primary">Elimina Establecimientos</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.createsQuests" class="md-primary">Crea Quests</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.modifiesQuests" class="md-primary">Modifica Quests</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.aprovesQuests" class="md-primary">Aprueba Quests</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.suspendsQuests" class="md-primary">Suspende Quests</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.deletesQuests" class="md-primary">Elimina Quests</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.downloadsExports" class="md-primary">Descarga Reportes de Jugadores</md-checkbox><br />
                        <md-checkbox v-model="form.permissions.deletesExports" class="md-primary">Elimina Reportes de Jugadores</md-checkbox><br />
                    </md-card-content>

                    <md-progress-bar md-mode="indeterminate" v-if="sending" />

                    <md-card-actions>
                    <md-button class="md-accent" @click="cancelForm()">Cancelar</md-button>
                    <md-button type="submit" class="md-primary" :disabled="sending">Guardar</md-button>
                    </md-card-actions>
                </md-card>

                </form>
            </md-content>

            <md-table v-model="users" md-sort="name" md-sort-order="asc" v-if="!showDialog" md-card md-fixed-header>
                <md-table-toolbar>
                    <h1 class="md-title">Usuarios</h1>
                    <md-button class="md-fab md-primary" @click="showForm()" v-if="acl.createsUsers && !loading">
                        <md-icon>add</md-icon>
                    </md-button>

                    <md-content class="text-xs-center" v-if="loading">
                        <p class="md-subheading md-layout md-alignment-top-center" v-bind:style="{ width: '100%' }">Cargando...</p>
                    </md-content>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!loading">
                    <md-table-cell md-label="Nombre" md-sort-by="name">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Email" md-sort-by="email">{{ item.email }}</md-table-cell>
                    <md-table-cell md-label="Creación" md-sort-by="createdAt">{{ item.createdAt | formatDate }}</md-table-cell>
                    <md-table-cell class="actions-cell">
                        <md-button class="md-icon-button md-primary" @click="editItem(item)" v-if="acl.modifiesUsers">
                            <md-icon>edit</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-accent" @click="deleteItem(item)" v-if="acl.deletesUsers">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  .md-app {
    border: 1px solid rgba(#000, .12);
  }
  .md-dialog {
    max-width: 768px;
  }
  .actions-cell {
    text-align: right;
  }
</style>

<script>
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig'
import {user} from '../helpers/user'
import axios from "axios";

export default {
    name: 'Users',
    components: {
        Header, Menu
    },
    data: () => ({
        menuVisible: false,
        loading: false,
        deleteConfirm: false,
        deleteItemId: null,
        users: [],
        showDialog: false,
        form: {
            name: null,
            email: null,
            password: null,
            permissions: {
                isAdmin: false,
                createsUsers: false,
                modifiesUsers: false,
                deletesUsers: false,
                createsCategories: false,
                modifiesCategories: false,
                aprovesCategories: false,
                suspendsCategories: false,
                deletesCategories: false,
                createsQuestions: false,
                modifiesQuestions: false,
                aprovesQuestions: false,
                deletesQuestions: false,
                createsSchools: false,
                modifiesSchools: false,
                aprovesSchools: false,
                suspendsSchools: false,
                deletesSchools: false,
                createsQuests: false,
                modifiesQuests: false,
                aprovesQuests: false,
                suspendsQuests: false,
                deletesQuests: false,
                downloadsExports: false,
                deletesExports: false,
            }
        },
        formForEdit: false,
        sending: false,
        lastUser: null,
        acl: {
            createsUsers: false,
            modifiesUsers: false,
            deletesUsers: false
        }
    }),
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
            if (liuser) {
                console.log('User logged in, go ahead...');
                var that = this;
                user.init(firebase.auth().currentUser, () => {
                    that.fetchData();
                });
            } else {
                this.$router.push('/auth')
                console.log('User not logged in!');
            }
        });
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        toggleMenu () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            this.users = [];
            this.loading = true;
            this.acl = {
                createsUsers: user.hasPermission('createsUsers'),
                modifiesUsers: user.hasPermission('modifiesUsers'),
                deletesUsers: user.hasPermission('deletesUsers')
            }
            console.log('this.form.acl', this.form.acl);

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/user", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result.data);
                    this.loading = false;
                    this.users = result.data;
                }, error => {
                    console.error(error);
                    this.loading = false;
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        },
        validateItem () {
            let validationError = false;
            if (!this.form.name) {
                validationError = true;
                alert('falta nombre');
            }
            if (!this.form.email) {
                validationError = true;
                alert('falta email');
            }
            if (!this.form.password && !this.formForEdit) {
                validationError = true;
                alert('falta clave');
            }

            if (!validationError) {
                if (this.formForEdit) {
                    axios({ 
                        "method": "PUT", 
                        "url": config.apiUrl + "/user/" + this.editItemId, 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                } else {
                    axios({ 
                        "method": "POST", 
                        "url": config.apiUrl + "/user", 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                }
            }
        },
        cleanForm () {
            this.form = {
                name: null,
                email: null,
                password: null,
                permissions: {
                    isAdmin: false,
                    createsUsers: false,
                    modifiesUsers: false,
                    deletesUsers: false,
                    createsCategories: false,
                    modifiesCategories: false,
                    aprovesCategories: false,
                    suspendsCategories: false,
                    deletesCategories: false,
                    createsQuestions: false,
                    modifiesQuestions: false,
                    aprovesQuestions: false,
                    deletesQuestions: false,
                    createsSchools: false,
                    modifiesSchools: false,
                    aprovesSchools: false,
                    suspendsSchools: false,
                    deletesSchools: false,
                    createsQuests: false,
                    modifiesQuests: false,
                    aprovesQuests: false,
                    suspendsQuests: false,
                    deletesQuests: false,
                    downloadsExports: false,
                    deletesExports: false,
                }
            }
            this.formForEdit = false;
            this.editItemId = null;
        },
        showForm () {
            this.showDialog = true;
        },
        hideForm () {
            this.showDialog = false;
        },
        cancelForm () {
            this.hideForm();
            this.cleanForm();
        },
        editItem (item) {
            console.log(item);
            this.form = {
                name: item.name,
                email: item.email,
                permissions: {
                    isAdmin: item.profile.isAdmin,
                    createsUsers: item.profile.createsUsers,
                    modifiesUsers: item.profile.modifiesUsers,
                    deletesUsers: item.profile.deletesUsers,
                    createsCategories: item.profile.createsCategories,
                    modifiesCategories: item.profile.modifiesCategories,
                    aprovesCategories: item.profile.aprovesCategories,
                    suspendsCategories: item.profile.suspendsCategories,
                    deletesCategories: item.profile.deletesCategories,
                    createsQuestions: item.profile.createsQuestions,
                    modifiesQuestions: item.profile.modifiesQuestions,
                    aprovesQuestions: item.profile.aprovesQuestions,
                    deletesQuestions: item.profile.deletesQuestions,
                    createsSchools: item.profile.createsSchools,
                    modifiesSchools: item.profile.modifiesSchools,
                    aprovesSchools: item.profile.aprovesSchools,
                    suspendsSchools: item.profile.suspendsSchools,
                    deletesSchools: item.profile.deletesSchools,
                    createsQuests: item.profile.createsQuests,
                    modifiesQuests: item.profile.modifiesQuests,
                    aprovesQuests: item.profile.aprovesQuests,
                    suspendsQuests: item.profile.suspendsQuests,
                    deletesQuests: item.profile.deletesQuests,
                    downloadsExports: item.profile.downloadsExports,
                    deletesExports: item.profile.deletesExports,
                }
            }
            this.formForEdit = true;
            this.editItemId = item.id;
            this.showForm();
        },
        deleteItem (item) {
            this.deleteConfirm = true;
            this.deleteItemId = item.id;
        },
        onDeleteConfirm () {
            axios({ 
                "method": "DELETE", 
                "url": config.apiUrl + "/user/" + this.deleteItemId, 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result);
                    this.fetchData();
                }, error => {
                    console.error(error);
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Users.vue